// @flow

import React from 'react';
import styled from 'styled-components';

import Link from 'react-router-dom/Link';

const Root = styled(Link)`
  flex-basis: 33.33%;
  padding-right: 15px;

  text-decoration: none;

  color: #3C3C3C;

  &:last-child {
    padding-right: 0;
  }
`

const Title = styled.h4`
  margin: 0;

  font-weight: normal;
  font-size: 27px;
`

const SubTitle = styled.h5`
  margin: 0;

  font-size: 13px;
  font-family: 'Georgia', serif;
  font-weight: normal;
  font-style: italic;
`

const Picture = styled.div`
  margin: 6px 0;
  height: 150px;
  background: #eee;
`

const Description = styled.div`
  font-size: 13px;
  font-family: 'Georgia', serif;
  font-weight: normal;
  line-height: 1.2;
`

type Props = {
  id: number,
  title: string,
  subTitle: string,
  description: string,
}

function Article({ id, title, subTitle, description }: Props) {
  return (
    <Root to={`/articles/${id}`}>
      <Title>
        {title}
      </Title>

      <SubTitle>
        {subTitle}
      </SubTitle>

      <Picture />

      <Description>
        {description}
      </Description>
    </Root>
  )
}

export default Article;



// WEBPACK FOOTER //
// ./src/components/ArticlesDrawer/Article.js